export default __webpack_public_path__ + "static/media/product-keke.ab78da04.png";